module.exports = __webpack_public_path__ + "platform/static/media/faqDrawer.4b92e729.svg";